var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.svgContent
    ? _c("div", {
        ref: "currentElRef",
        staticClass: "svg-container",
        domProps: { innerHTML: _vm._s(_setup.svgContent) },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }